import React from "react";
import AddDepositComponents from "../components";

export default function AddDeposit() {
  return <AddDepositComponents />;
}
